import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ZoomableService } from '../services/zoomable.service';

@Component({
  template: '',
})
export class ZoomableHeaderComponent implements OnInit, OnDestroy {
  @Input() public zoomId: string;

  public isEnabled = false;

  private zoomInSubscription: Subscription = Subscription.EMPTY;
  private zoomOutSubscription: Subscription = Subscription.EMPTY;
  private zoomSubscription: Subscription = Subscription.EMPTY;

  public constructor(protected zoomableService: ZoomableService) {}

  public ngOnInit(): void {
    this.zoomSubscription = this.zoomableService.zoom$.subscribe((state) => {
      if (state.match === false && state.zoomId === this.zoomId) {
        this.isEnabled = false;
      }
    });

    this.zoomOutSubscription = this.zoomableService.zoomOut$.subscribe((state) => {
      if (this.zoomId !== state.zoomId) {
        return;
      }

      if (state.scale !== null) {
        this.isEnabled = true;
      }
    });

    this.zoomInSubscription = this.zoomableService.zoomIn$.subscribe((state) => {
      if (this.zoomId !== state.zoomId) {
        return;
      }

      this.isEnabled = false;
    });
  }

  public onCloseClick(): void {
    this.zoomableService.zoomOut$.emit({ zoomId: this.zoomId, match: true, scale: null });
  }

  public ngOnDestroy(): void {
    if (this.zoomOutSubscription !== Subscription.EMPTY) {
      this.zoomOutSubscription.unsubscribe();
      this.zoomOutSubscription = Subscription.EMPTY;
    }

    if (this.zoomInSubscription !== Subscription.EMPTY) {
      this.zoomInSubscription.unsubscribe();
      this.zoomInSubscription = Subscription.EMPTY;
    }

    if (this.zoomSubscription !== Subscription.EMPTY) {
      this.zoomSubscription.unsubscribe();
      this.zoomSubscription = Subscription.EMPTY;
    }
  }
}
